export default function () {
  /* 表格列头 */
  return [
    { label: "序号", type: "index", width: 80 },
    // { label: "公众号ID", prop: "id", width: 300 },
    { label: "公众号名称", prop: "account_name", width: 300 },
    { label: "appid", prop: "appid" },
    {
      label: "创建时间",
      prop: "create_time",
      width: 180,
      // slots: "state",
    },
    {
      label: "操作",
      prop: "operation",
      width: 150,
      slots: "operation",
      // fixed: "right",
    },
  ];
}
